//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/NXObject.js";
let d=[[],[],[]];
SPLM.VisualReporting.Classifier = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.VisualReporting.Classifier";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualReporting.Classifier.TypeOption = Object.freeze({
    "Simple" : "Simple", "Value" : "Value", "Range" : "Range"});

SPLM.VisualReporting.Classifier.GroupingMethodOption = Object.freeze({
    "Manual" : "Manual", "Automatic" : "Automatic", "SemiAutomatic" : "SemiAutomatic"});

SPLM.VisualReporting.Classifier.RangeMethodOption = Object.freeze({
    "Number" : "Number", "Percentage" : "Percentage"});

SPLM.VisualReporting.Classifier.DateGroupMethodOption = Object.freeze({
    "Day" : "Day", "Week" : "Week", "Month" : "Month", "Year" : "Year"});

export default SPLM;